import { render } from "./Public.vue?vue&type=template&id=c65507d2&ts=true"
import script from "./Public.vue?vue&type=script&lang=ts"
export * from "./Public.vue?vue&type=script&lang=ts"

import exportComponent from "/app/frontend-danahealth/dsg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__